import SftpUser from 'umg-ember-backend/components/record-explorer/for/sftp-user';

<template><SftpUser @records={{@model}} @recordType='sftp-user' /></template>
